<template lang="pug">
  .component-backoffice-driver-list.row.column

    .row
      .column.small-4
        label Status
          select(v-model="search.status", :disabled="search.deleted")
            option(:value="null") All
            option NEW
            option WAITING
            option ACCEPTED
            option REJECTED
      .column
        label Show deleted
          input-switch(v-model="search.deleted" )
    base-list(:component="component", :dataLoader="dataLoader", :search="search")
</template>

<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'

import InputForm from "../../components/structure/ui/filters/InputForm";
import BaseList from "./BaseList";
import HeaderColumns from "../../components/structure/ui/HeaderColumns";
import DriverListForm from '../../components/structure/ui/filters/DriverListForm'
import InputSwitch from "../../components/structure/ui/InputSwitch.vue";

export default {
  name: "DriversReservationRequestList",
  components: {
    InputSwitch,
    DriverListForm,
    HeaderColumns,
    BaseList,
    InputForm,
  },
  data: function () {
    return {
      component: require('src/components/backoffice/DriverReservationRequest.vue'),
      search: {
        status: null,
        deleted: false,
      }
    }
  },
  methods: {
    dataLoader(callback, page, resultsPerPage) {
      KeplerBackofficeSdk.reservations.list(page, resultsPerPage).driversReservationRequests(this.search,(data) => {
        callback(data)
      })
    },
  }
}
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DriversReservationRequestList.vue?101a51ce